// extracted by mini-css-extract-plugin
module.exports = {"titre":"Card_titre__2jXJ2","container":"Card_container__JGDP1","description":"Card_description__1pVlS","card":"Card_card__2jIOB"};